module.exports = __webpack_public_path__ + "static/foto-d46edd1a084072b80acbfa210e248555.jpg";